<template>
  <div>
    <items-list :businessId="businessId" :query="query" :filters="filters" :targetEntityId="targetEntityId" category="deleted" @history="history" />
  </div>
</template>

<script>
import ItemsList from "@/views/business/todo/components/ItemsList";

export default {
  name: "DeletedTodoView",
  props: {
    businessId: String,
    query: String,
    targetEntityId: String,
    filters: Object,
  },
  components: { ItemsList },
  methods: {
    history(item) {
      this.$emit("history", item);
    },
  },
};
</script>
